  <div class="container padding d-flex fd-row" [ngClass]="{'focused': isFocused }">

  <div class="flex-1 d-flex flex-wrap ai-center">
    <p class="entry">{{ name }}</p>
  </div>

  <!-- Invite Buttons -->
  <div class="entry-buttons-container d-flex fd-row jc-end ai-center">
    <button mat-icon-button class="edit-entry" (click)="action(true)">
      <mat-icon>check</mat-icon>
    </button>
    <button mat-icon-button class="edit-entry" (click)="action(false)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

</div>